// Embedded lookup tables from legacy DE-variant calculator JSON files.
// Data structure: { type: { height: { depth: { '70/55': watts, '75/65': watts } } } }
// Values are watts per single element at the given temperature condition.
const DE_VARIANT_DATA = {
  Stahlrohre: {
    190: { 65: { '70/55': 11.2, '75/65': 14 }, 105: { '70/55': 16, '75/65': 20 }, 145: { '70/55': 20.8, '75/65': 26 } },
    260: { 65: { '70/55': 15.2, '75/65': 19 }, 105: { '70/55': 20.8, '75/65': 26 }, 145: { '70/55': 26.4, '75/65': 33 }, 185: { '70/55': 33.6, '75/65': 42 }, 225: { '70/55': 37.6, '75/65': 47 } },
    300: { 65: { '70/55': 17.6, '75/65': 22 }, 105: { '70/55': 24.8, '75/65': 31 }, 145: { '70/55': 32, '75/65': 40 }, 185: { '70/55': 38.4, '75/65': 48 }, 225: { '70/55': 45.6, '75/65': 57 } },
    400: { 65: { '70/55': 22.4, '75/65': 28 }, 105: { '70/55': 32.8, '75/65': 41 }, 145: { '70/55': 41.6, '75/65': 52 }, 185: { '70/55': 51.2, '75/65': 64 }, 225: { '70/55': 60, '75/65': 75 } },
    500: { 65: { '70/55': 29.6, '75/65': 37 }, 105: { '70/55': 40.8, '75/65': 51 }, 145: { '70/55': 52, '75/65': 65 }, 185: { '70/55': 64, '75/65': 80 }, 225: { '70/55': 75.2, '75/65': 94 } },
    600: { 65: { '70/55': 35.2, '75/65': 44 }, 105: { '70/55': 48, '75/65': 60 }, 145: { '70/55': 61.6, '75/65': 77 }, 185: { '70/55': 52, '75/65': 65 }, 225: { '70/55': 90.4, '75/65': 113 } },
    750: { 65: { '70/55': 44, '75/65': 55 }, 105: { '70/55': 60, '75/65': 75 }, 145: { '70/55': 76, '75/65': 95 }, 185: { '70/55': 93.6, '75/65': 117 }, 225: { '70/55': 109.6, '75/65': 137 } },
    900: { 65: { '70/55': 53.6, '75/65': 67 }, 105: { '70/55': 71.2, '75/65': 89 }, 145: { '70/55': 89.6, '75/65': 112 }, 185: { '70/55': 110.4, '75/65': 138 }, 225: { '70/55': 130.4, '75/65': 163 } },
    1000: { 65: { '70/55': 58.4, '75/65': 73 }, 105: { '70/55': 78.4, '75/65': 98 }, 145: { '70/55': 99.2, '75/65': 124 }, 185: { '70/55': 120.8, '75/65': 151 }, 225: { '70/55': 144, '75/65': 180 } },
    1200: { 65: { '70/55': 68.8, '75/65': 86 }, 105: { '70/55': 92.8, '75/65': 116 }, 145: { '70/55': 117.6, '75/65': 147 }, 185: { '70/55': 143.2, '75/65': 179 }, 225: { '70/55': 167.2, '75/65': 209 } },
    1500: { 65: { '70/55': 84.8, '75/65': 106 }, 105: { '70/55': 114.4, '75/65': 143 }, 145: { '70/55': 144, '75/65': 180 }, 185: { '70/55': 172, '75/65': 215 }, 225: { '70/55': 200, '75/65': 250 } },
    2000: { 65: { '70/55': 112, '75/65': 140 }, 105: { '70/55': 151.2, '75/65': 189 }, 145: { '70/55': 189.6, '75/65': 237 }, 185: { '70/55': 225.6, '75/65': 282 }, 225: { '70/55': 264, '75/65': 330 } },
    2500: { 65: { '70/55': 139.2, '75/65': 174 }, 105: { '70/55': 188.8, '75/65': 236 }, 145: { '70/55': 236, '75/65': 295 }, 185: { '70/55': 277.6, '75/65': 347 }, 225: { '70/55': 322.4, '75/65': 403 } },
  },
  Stahlrippe: {
    300: { 160: { '70/55': 30.4, '75/65': 38 }, 250: { '70/55': 46.4, '75/65': 58 } },
    450: { 110: { '70/55': 33.6, '75/65': 42 }, 160: { '70/55': 44.8, '75/65': 56 }, 220: { '70/55': 60, '75/65': 75 } },
    600: { 110: { '70/55': 44, '75/65': 55 }, 160: { '70/55': 60, '75/65': 75 }, 220: { '70/55': 76.8, '75/65': 96 } },
    1000: { 110: { '70/55': 73.6, '75/65': 92 }, 160: { '70/55': 94.4, '75/65': 118 }, 220: { '70/55': 123.2, '75/65': 154 } },
  },
  Gussradiator: {
    280: { 250: { '70/55': 55.2, '75/65': 69 } },
    430: { 70: { '70/55': 32.8, '75/65': 41 }, 110: { '70/55': 42.4, '75/65': 53 }, 160: { '70/55': 56, '75/65': 70 }, 220: { '70/55': 73.6, '75/65': 92 } },
    580: { 70: { '70/55': 40.8, '75/65': 51 }, 110: { '70/55': 55.2, '75/65': 69 }, 160: { '70/55': 76, '75/65': 95 }, 220: { '70/55': 97.6, '75/65': 122 } },
    680: { 160: { '70/55': 88.8, '75/65': 111 } },
    980: { 70: { '70/55': 67.2, '75/65': 84 }, 160: { '70/55': 123.2, '75/65': 154 }, 220: { '70/55': 156.8, '75/65': 196 } },
  },
}

export const deVariantData = {
  types: ['Stahlrohre', 'Stahlrippe', 'Gussradiator'],
  temperatureConditions: ['70/55', '75/65'],
  elements: Array.from({ length: 25 }, (_, i) => i + 1),
}

export function getHeightsForType(type) {
  const typeData = DE_VARIANT_DATA[type]
  if (!typeData) return []
  return Object.keys(typeData).map(Number)
}

export function getDepthsForType(type, height) {
  const typeData = DE_VARIANT_DATA[type]
  if (!typeData) return []
  const heightData = typeData[height]
  if (!heightData) return []
  return Object.keys(heightData).map(Number)
}

export function deVariantWatts(type, height, depth, numberOfElements, tempCondition = '70/55') {
  const typeData = DE_VARIANT_DATA[type]
  if (!typeData) return 0
  const heightData = typeData[height]
  if (!heightData) return 0
  const depthData = heightData[depth]
  if (!depthData) return 0
  const wattsPerElement = depthData[tempCondition]
  if (wattsPerElement == null) return 0
  return Math.round(wattsPerElement * numberOfElements)
}
